import { LabelTypeMetadata } from "../NutritionLabels/LabelTypeMetadata";
import { CanadaFOPHighInMetadata } from "../NutritionLabels/CanadaFOPHighInMetadata";

export class Nutritions {
  addedSugarPerServing: number = 0;
  unadjustedAddedSugarPerServing: number = 0;
  sugarAlcohols: number = 0;
  alcoholSugarDv: number = 0;
  ironDv: number = 0;
  iron: number = 0;
  calciumDv: number = 0;
  calcium: number = 0;
  potassiumDv: number = 0;
  potassium: number = 0;
  vitaminDDv: number = 0;
  vitaminD: number = 0;
  vitaminC: number = 0;
  sodiumDv: number = 0;
  sodium: number = 0;
  cholesterol: number = 0;
  cholesterolDv: number = 0;
  protein: number = 0;
  sugarsDv: number = 0;
  sugars: number = 0;
  fibreDv: number = 0;
  fibre: number = 0;
  carbohydrate: number = 0;
  carbohydrateDv: number = 0;
  transFatDv: number = 0;
  transFat : number = 0;
  saturatedFatDv: number = 0;
  saturatedFat: number = 0;
  fatDv: number = 0;
  fat: number = 0;
  calories: number = 0;
  servingWeight: number = 0;
  saturatedAndTransDv: number = 0;
  servingQuantityInUnitOfMeasurement: number = 0;
  erythritol: number = 0;
  isomalt: number = 0;
  mannitol: number = 0;
  xylitol: number = 0;
  lactitol: number = 0;
  sorbitol: number = 0;
  maltitol: number = 0;
  monounsaturatedFats: number = 0;
  polyunsaturatedFats: number = 0;
  omega3: number = 0;
  omega6: number = 0;
  caffeine: number = 0;
  ash: number = 0;
  water: number = 0;
  moisture: number = 0;
  unspecified: number = 0;
  servingUnitOfMeasurement: string = 'g';
  // addedSugars: number,
  // addedSugarsDv: number,

  weight: number = 0;
  weightPerServing: number = 0;
  rawWeight: number = 0;
  rawWeightPerServing: number = 0;

  volume: number | null;
  rawVolume: number | null;
  volumePerServing: number | null;
  rawVolumePerServing: number | null;

  quantityPerServingInUnitOfMeasurement: {
    item1: number; // quantity
    item2: string; // unit of measurement
  };

  labelType : LabelTypeMetadata | LabelTypeMetadata.BackOfPack;

  additionalLabelInformation: {
    [LabelTypeMetadata.FrontOfPack]?: {
      frontOfPackageNutritionLabelId: number;
      highInMetadata : CanadaFOPHighInMetadata;
    }
  };
}